import { IPhraseTriggerSampleParameters, IPhraseTriggerSamplesResponse } from "@edgetier/watchtower-types";
import { PHRASE_TRIGGER_DEFAULT_SIMILARITY_THRESHOLD, PHRASE_TRIGGER_SAMPLES_LIMIT } from "constants/phrase-triggers";
import { axios } from "utilities/axios";

/**
 * Request phrase trigger samples.
 * @param url              Phrase trigger URL.
 * @param parameters
 * @param nextPage         Optional URL of the next page to load.
 * @returns                Promise of an array of phrase trigger samples.
 */
export const requestPhraseTriggerSamples = async (
    url: string,
    parameters: IPhraseTriggerSampleParameters,
    nextPage: string | undefined
) => {
    const requestParameters: IPhraseTriggerSampleParameters = {
        ...parameters,
        similarityThreshold: PHRASE_TRIGGER_DEFAULT_SIMILARITY_THRESHOLD,
        limit: PHRASE_TRIGGER_SAMPLES_LIMIT,
    };

    // If loading the next page, the backend provides a full URL. Otherwise construct a search query.
    const request = nextPage
        ? axios.get<IPhraseTriggerSamplesResponse>(nextPage)
        : axios.get<IPhraseTriggerSamplesResponse>(url, { params: requestParameters });

    const response = await request;
    return response.data;
};
